import _ from 'lodash';
import React, { AnchorHTMLAttributes, PropsWithChildren } from 'react';

type IProps = AnchorHTMLAttributes<any> & {
  imageSignature?: string | null;
};

const Link: React.FC<PropsWithChildren<IProps>> = (props) => {
  const { children, href, imageSignature, className, ...rest } = props;

  const _href = imageSignature ? `${href}?${imageSignature}` : href;

  return <>
    {href || !_.isEmpty(href) ?
      <a href={_href} className={`hover:text-blue-950 ${className}`} {...rest}>{children}</a> :
      <span className={className} {...rest} >{children}</span>}
  </>
}

export default Link;
